import { render } from "./TitleSection.vue?vue&type=template&id=2019d126"
import script from "./TitleSection.vue?vue&type=script&lang=js"
export * from "./TitleSection.vue?vue&type=script&lang=js"

import "./TitleSection.vue?vue&type=style&index=0&id=2019d126&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__